import React, { useEffect, useRef, useState } from "react";
import { useLang } from "../../context/langProvider";
import "./styles.css";

const countries = [
  { code: "at", labelKey: "autriche", flag: "https://flagcdn.com/w40/at.png" },
  { code: "be", labelKey: "belgique", flag: "https://flagcdn.com/w40/be.png" },
  { code: "bg", labelKey: "bulgarie", flag: "https://flagcdn.com/w40/bg.png" },
  { code: "hr", labelKey: "croatie", flag: "https://flagcdn.com/w40/hr.png" },
  { code: "cy", labelKey: "chypre", flag: "https://flagcdn.com/w40/cy.png" },
  { code: "cz", labelKey: "republique-tcheque", flag: "https://flagcdn.com/w40/cz.png" },
  { code: "dk", labelKey: "danemark", flag: "https://flagcdn.com/w40/dk.png" },
  { code: "ee", labelKey: "estonie", flag: "https://flagcdn.com/w40/ee.png" },
  { code: "fi", labelKey: "finlande", flag: "https://flagcdn.com/w40/fi.png" },
  { code: "fr", labelKey: "france", flag: "https://flagcdn.com/w40/fr.png" },
  { code: "de", labelKey: "allemagne", flag: "https://flagcdn.com/w40/de.png" },
  { code: "gr", labelKey: "grece", flag: "https://flagcdn.com/w40/gr.png" },
  { code: "hu", labelKey: "hongrie", flag: "https://flagcdn.com/w40/hu.png" },
  { code: "ie", labelKey: "irlande", flag: "https://flagcdn.com/w40/ie.png" },
  { code: "it", labelKey: "italie", flag: "https://flagcdn.com/w40/it.png" },
  { code: "lv", labelKey: "lettonie", flag: "https://flagcdn.com/w40/lv.png" },
  { code: "lt", labelKey: "lituanie", flag: "https://flagcdn.com/w40/lt.png" },
  { code: "lu", labelKey: "luxembourg", flag: "https://flagcdn.com/w40/lu.png" },
  { code: "mt", labelKey: "malte", flag: "https://flagcdn.com/w40/mt.png" },
  { code: "nl", labelKey: "pays-Bas", flag: "https://flagcdn.com/w40/nl.png" },
  { code: "pl", labelKey: "pologne", flag: "https://flagcdn.com/w40/pl.png" },
  { code: "pt", labelKey: "portugal", flag: "https://flagcdn.com/w40/pt.png" },
  { code: "ro", labelKey: "roumanie", flag: "https://flagcdn.com/w40/ro.png" },
  { code: "sk", labelKey: "slovaquie", flag: "https://flagcdn.com/w40/sk.png" },
  { code: "si", labelKey: "slovenie", flag: "https://flagcdn.com/w40/si.png" },
  { code: "es", labelKey: "espagne", flag: "https://flagcdn.com/w40/es.png" },
  { code: "se", labelKey: "suede", flag: "https://flagcdn.com/w40/se.png" }
];

const CountrySelect = ({ value, onChange }) => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = countries.find(c => c.code === value) || countries[9]; // default: france

  const handleSelect = (country) => {
    onChange(country.code); // 🔁 Utilise la prop onChange
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="country-select" ref={dropdownRef}>
      <div className="selected" onClick={() => setOpen(!open)}>
        <img src={selected.flag} alt={selected.code} />
        {t(selected.labelKey)}
        <span className="arrow">{open ? "▲" : "▼"}</span>
      </div>
      {open && (
        <ul className="dropdown">
          {countries.map((country) => (
            <li key={country.code} onClick={() => handleSelect(country)}>
              <img src={country.flag} alt={country.code} />
              {t(country.labelKey)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CountrySelect;
